import { $http } from '@/utils/https';
import type { Product } from '@/types/shop';

interface State {
  isGiftsLoading: boolean;
  gifts: Product | null;
}

const state: State = {
  isGiftsLoading: false,
  gifts: null
};

const getters = {
  isGiftsLoading: (state: State) => state.isGiftsLoading,
  gifts: (state: State) => state.gifts
};

const actions = {
  CHECK_GIFTS: async ({ commit }: any, payload: any) => {
    try {
      commit('CHANGE_GIFT_LOADING', true);
      const response = await $http.get<{ data: Product }>('v1/products/check-gift', {
        params: payload
      });
      commit('SET_GIFTS', response.data.data);
      return response.data.data;
    } catch (e) {
      throw e;
    } finally {
      commit('CHANGE_GIFT_LOADING', false);
    }
  }
};

const mutations = {
  CHANGE_GIFT_LOADING(state: State, status: boolean) {
    state.isGiftsLoading = status;
  },
  SET_GIFTS(state: State, gifts: Product) {
    // @ts-ignore
    state.gifts = gifts;
  }
};

//294/100

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
